/* eslint-disable prefer-const */
import Button from '_atoms/Button/Button';
import {
    PROGRESS_BAR_END_VALUE,
    PROGRESS_BAR_END_VALUE_REBOARDING,
} from '_constants/questionTreeConstants';
import i18n from '_i18n';
import usePremiumInfo from '_services/Redux/User/Selector/usePremiumInfo';
import { OnboardingPage } from '_types/question';
import { t } from 'i18next';
import React from 'react';
import './ImageQuestionScreen.scss';

interface ImageQuestionScreenProps {
    question: OnboardingPage;
    onAnswer: () => void;
    isReboarding: boolean;
}

const ImageQuestionScreen: React.FC<ImageQuestionScreenProps> = ({
    question,
    onAnswer,
    isReboarding,
}) => {
    if (question.type !== 'image') {
        return null;
    }

    let {
        text,
        illustration,
        adjustIllustrationUp,
        backgroundImage,
        buttonText,
        progress,
    } = question;
    const language: LanguageCode = i18n.language === 'no' ? 'no' : 'en';
    const { isPremium } = usePremiumInfo();

    if (isPremium && backgroundImage && illustration) {
        illustration = undefined;
    }

    const cta =
        typeof buttonText === 'function'
            ? buttonText(isReboarding, isPremium)
            : buttonText;
    const displayText =
        typeof text === 'function' ? text(isReboarding, isPremium) : text;
    const progressBarEndValue = isReboarding
        ? PROGRESS_BAR_END_VALUE_REBOARDING
        : PROGRESS_BAR_END_VALUE;

    const progressBarWidth = progress
        ? (progress(isReboarding) / progressBarEndValue) * 100
        : 0;
    return (
        <div
            className="image-question-page-wrapper"
            {...(backgroundImage && { style: { backgroundImage } })}
        >
            {progressBarWidth > 0 && (
                <div className="progress-bar-container">
                    <div
                        className="progress-bar-fill"
                        style={{
                            width: `${progressBarWidth}%`,
                        }}
                    />
                </div>
            )}

            {illustration && (
                <div
                    className={`image-question-background-image ${adjustIllustrationUp ? 'adjust-illustration-up' : ''}`}
                >
                    <img src={illustration} alt="background" />
                </div>
            )}
            <div className="image-question-gradient-section">
                <div className="image-question-lower-gradient"></div>
                <div className="image-question-bottom-section"></div>
            </div>

            <div className="intro-text-wrapper">
                <h2
                    dangerouslySetInnerHTML={{ __html: displayText[language] }}
                ></h2>
            </div>
            <div className="navigation-container">
                <Button classes="next-button" onClick={() => onAnswer()}>
                    {cta?.[language] || t('Continue')}
                </Button>
            </div>
        </div>
    );
};

export default ImageQuestionScreen;
